var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"time"},[_c('timeago',{attrs:{"datetime":_vm.datetime,"converter-options":{
      format: 'PPP',
      forceDateFormat: true
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }